import React from "react";
import { Modal } from "react-bootstrap";
import LHMap from "../../Utilities/LHMap";

const LocateSBU = ({ showMap, setShowMap, data, setter }) => {
  return (
    <Modal size="xl" show={showMap.show} onHide={() => setShowMap({ show: false, data: {} })}>
      <Modal.Header closeButton className="Map-Modal-Header">

        <Modal.Title id="example-modal-sizes-title-lg">
          <span className="modal-title-text">
            {showMap?.data?.serviceType === "CB" ?
              "Pin Your Location" : "LOCATE NEAR BY SBU"}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LHMap showMap={showMap} data={data} setter={setter} setShowMap={setShowMap}/>
      </Modal.Body>
    </Modal >
  );
};

export default LocateSBU;
